<script type="text/jsx" lang="jsx">
import { createEditDeltaComponent } from '@/components/edit-delta-factory';
import commonMixin from '@/plans/ZOOM_CLIPS/mixin';
import { planTypes } from '@/common/constants';

export default createEditDeltaComponent({
  name: 'ClipsEditDelta',
  planType: planTypes.ZOOM_CLIPS,
  mixin: commonMixin,
});
</script>

<style lang="scss">
.opc-zwb {
  &__preview-payment {
    margin-top: 24px;
  }
}
</style>
